import { withKeys } from "../lib/keys";

const PH = { Severity: "cc-chip-critical", Resuscitation: "cc-chip-critical", Diagnosis: "cc-chip-ok", Treatment: "cc-chip-warn", Haemodynamics: "cc-chip-warn", Ventilation: "cc-chip-warn", Pharmacotherapy: "cc-chip-warn", Monitoring: "cc-chip-ok", Prognosis: "" };

const nodeClass = (isCurrent, status) => {
  if (isCurrent) return "is-current";
  if (status === "done") return "is-done";
  return "";
};

const FlowStep = ({ s, i, isCurrent, testid }) => (
  <li className={`cc-flow-node ${nodeClass(isCurrent, s.status)}`} data-testid={`${testid}-step-${i}`}>
    <div className="cc-flow-box">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-mono text-xs">{i + 1}</span>
        {s.phase && <span className={`cc-chip ${PH[s.phase] || ""}`}>{s.phase}</span>}
        <span className="font-medium text-sm">{s.step}</span>
        {isCurrent && <span className="cc-chip cc-chip-critical ml-auto">Patient is here</span>}
      </div>
      {s.decision && <div className="cc-flow-decision">{s.decision}</div>}
      {s.timing && <div className="text-xs text-muted-foreground font-mono mt-1.5" data-testid={`${testid}-timing-${i}`}>Timing: {s.timing}</div>}
    </div>
  </li>
);

export const AlgorithmFlow = ({ algo, testid }) => {
  if (!algo?.steps?.length) return null;
  const firstCurrent = algo.steps.findIndex((s) => s.status === "current");
  return (
    <div className="border rounded-md bg-card p-6" data-testid={testid}>
      <div className="cc-label text-[var(--cc-blue)]">Syndromic algorithm · {algo.ref}</div>
      <div className="font-heading text-lg font-semibold mt-1 mb-5">{algo.name}</div>
      <ol className="cc-flow">
        {withKeys(algo.steps, (s) => s.step).map(([key, s], i) => (
          <FlowStep key={key} s={s} i={i} isCurrent={i === firstCurrent} testid={testid} />
        ))}
      </ol>
    </div>
  );
};
